<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import {COUNTRY_ARRIVO, IATA_ARRIVO, WS_URL} from '../../utils/config'
import {ERROR_GENERIC} from '../../utils/messages'
import ServiziActions from './ServiziAction'
import moment from '../../../../node_modules/moment'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'

export default {
  name: 'SearchVoloHotelAction',
  mixins: [ServiziActions],
  methods: {
    ...mapActions(['loadingStartWithSlider', 'loadingEndWithSlider']),
    searchVoloHotel (searchData) {
      const voloGiornoSuccessivo = this.$store.getters.getVettori.voloGiornoSuccessivo
      const codiceHotelAlternativo = this.$store.getters.getVettori.codiceHotelAlternativo
      const vettori = this.$store.getters.getVettori.list.map(item => {
        return item.id
      })
      const hotels = this.$store.getters.getHotels.list.map(item => {
        return {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice.trim()}
      })
      const servizi = this.getAllServiziToSearch()
      const camere = searchData.camere.map((item, index) => {
        return {id: index + 1, adults: item.adults, childs: item.childs}
      })

      const hotelStart = this.$store.getters.isGiornoSuccessivoObbligatorio ? moment(searchData.andata, SERVER_DATE_FORMAT).add('days', 1).format(SERVER_DATE_FORMAT) : searchData.andata

      const payload = {
        hotelPeriods: [[hotelStart, searchData.ritorno]],
        travelGroup: camere,
        flightRequest: {
          iataPartenza: searchData.aereoporto.value,
          iataArrivo: IATA_ARRIVO,
          startDate: searchData.andata,
          endDate: searchData.ritorno,
          vettori: vettori,
          voloGiornoSuccessivo,
          codiceHotelAlternativo
        },
        hotels: hotels,
        servizi: servizi
      }
      this.loadingStartWithSlider()
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${WS_URL}experience/record`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            const error = {error: true, messages: data.messages}
            this.$toastr.error(data.messages[0].message)
            reject(error)
          } else {
            resolve(response)
          }
        }).catch(error => {
          this.$toastr.error(ERROR_GENERIC)
          reject(error)
        }).finally(() => {
          this.loadingEndWithSlider()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/SearchVoloHotelAction.vue